import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { LoadingOld } from '@components/LoadingOld/LoadingOld';
import InputDefault from '@components/InputDefault/InputDefault';

import DatePicker from 'react-datepicker';
import CurrencyInput from 'react-currency-input';

import ReactModal from 'react-modal';
import Switch from 'react-switch';

import 'react-datepicker/dist/react-datepicker.css';

import { UPDATE_AD } from '@redux/feed/types';

import { handleNewEventMixPanel } from '@utils/helpers';

const Wrapper = styled('div')`
  display: flex;
  min-height: 100px;
  height: auto;

  .react-datepicker-wrapper {
    width: 100px;
    & > div {
      & > input {
        width: 94px;
        height: 34px;
        border: none;
        background: #f2f2f2 0% 0% no-repeat padding-box;
        border-radius: 6px;
        color: ${(props) => (props.hasError ? '#B51D42' : '#0087C8')};
        font-size: 14px;
        text-align: center;
      }
      *:focus {
        outline: none;
      }

      & > input:disabled {
        cursor: not-allowed;
      }
    }
  }
`;

const Period = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  position: relative;

  border-right: 0.5px solid #c3cfd6;
`;

const PeriodText = styled('div')`
  top: 0;
  position: absolute;
  color: #304e5c;
  font-size: 14px;
`;

const Budget = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  position: relative;
`;

const CustomInput = styled(CurrencyInput)`
  display: block;
  outline: none;
  font-size: 14px;
  color: #00967d;
  text-align: center;
  width: 100%;
  height: 34px;
  border: none;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 6px;
`;

const LinkWrapper = styled('div')`
  margin-top: 8px;
`;

const LinkLabel = styled.div`
  margin-bottom: 8px;
  color: #304e5c;
  font-size: 14px;
`;

const OptionalLabel = styled.div`
  text-align: right;
  color: #314e5d;
  font-size: 12px;
  margin-top: 8px;
`;

const LoadingWrapper = styled('div')`
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 1;
  background: white;
  opacity: 0.75;
  left: 0;
  top: 0;
`;

const Title = styled.div`
  color: #4c5564;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  margin-bottom: 10px;
`;

const Subtitle = styled.div`
  color: #314e5d;
  font-size: 12px;
  text-align: left;
  margin-bottom: 40px;
`;

const FooterWrapper = styled.div`
  height: 86px;
  display: flex;
  justify-content: end;
  position: absolute;
  bottom: 0;
  right: 0px;
  left: 0px;
  border-top: 0.5px solid #c3cfd6;
`;
const SaveApproveButton = styled.div`
  border-radius: 10px;
  color: #ffffff;
  background-color: #0087c8;
  font-size: 14px;
  width: 136px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin-top: 25px;
  margin-bottom: 25px;
  margin-right: 32px;
  cursor: pointer;
`;
const CancelButton = styled.div`
  color: #577584;
  font-size: 14px;
  width: 136px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin-top: 25px;
  margin-bottom: 25px;
  cursor: pointer;
`;

const SwitchWrapper = styled.div`
  position: absolute;
  right: 32px;
  top: 34px;
`;

const SwitchText = styled.div`
  color: #2dbff3;
  font-size: 10px;
  position: absolute;
  right: 35px;
  width: 73px;
`;

class EditModal extends Component {
  state = {
    startDate: '',
    endDate: '',
    budget: '',
    budgetToSend: 0,
    endDateToSend: '',
    changedEndDate: false,
    changedBudget: false,
    startDateToSend: '',
    budgetType: '',
    linkValue: '',
    checked: false,
  };

  componentDidMount() {
    const {
      props: { media },
    } = this;

    if (media.start_time) this.setStartDate(new Date(media.start_time));
    if (media.end_time) this.setEndDate(new Date(media.end_time));
    if (media.daily_budget) {
      this.setBudget('Orçamento diário', media.daily_budget);
    } else if (media.lifetime_budget) {
      this.setBudget('Orçamento vitalício', media.lifetime_budget);
    }

    if (media.link_url) this.setLinkUrl(media.link_url);

    if (media.status === 'active') {
      this.setState({
        checked: true,
      });
    }
  }

  closeModal = () => {
    const {
      props: { closeModal },
    } = this;

    closeModal();
  };

  handleSubmit = () => {
    const {
      props: {
        dispatch,
        media,
        match: {
          params: { code },
        },
      },
    } = this;

    handleNewEventMixPanel(
      'click_confirm_edit_ad_feed_web_button',
      'view',
      this.props.authenticationReducer,
      this.props.match
    );

    let tempStart;

    if (media.status === 'paused' || media.status === 'active' || media.status === 'finished') {
      this.setState({
        startDateToSend: null,
      });
      tempStart = null;
    }

    if (this.state.budget === this.state.budgetToSend) {
      this.setState({
        budgetToSend: null,
      });
      this.setState({
        changedBudget: false,
      });
    }

    let tempLink = '';

    if (this.state.linkValue === media.link_url) {
      tempLink = null;
    }

    let tempStatus = '';

    if (this.state.checked) {
      tempStatus = 'active';
    } else if (media.status === 'active') {
      tempStatus = 'paused';
    }

    dispatch({
      type: UPDATE_AD.REQUEST,
      version: '1.1',
      code: code,
      adId: media.id,
      body: {
        start_date: tempStart === null ? tempStart : this.state.startDateToSend,
        end_date: this.state.changedEndDate ? this.state.endDateToSend : null,
        budget: this.state.changedBudget ? this.state.budgetToSend.replace(/\./g, '') : null,
        call_to_action_link_url: tempLink == null ? tempLink : this.state.linkValue,
        timezone_offset: -3,
        status: tempStatus === '' ? media.status : tempStatus,
      },
    });

    this.closeModal();
  };

  setStartDate(date) {
    let newValue = new Date(date);

    newValue = newValue.toISOString().split('T')[0];

    this.setState({
      startDate: date,
      startDateToSend: newValue,
    });
  }

  setEndDate(date) {
    // let newValue = new Date(date);

    // newValue = newValue.toISOString().split('T')[0];

    var tzoffset = new Date().getTimezoneOffset() * 60000;
    var localISOTime = new Date(new Date(date) - tzoffset).toISOString().slice(0, -1);

    this.setState({
      endDate: date,
      endDateToSend: localISOTime,
    });
  }

  setBudget(type, value) {
    this.setState({
      budgetType: type,
      budget: value,
      budgetToSend: value,
    });
  }

  setLinkUrl(value) {
    this.setState({
      linkValue: value,
    });
  }

  changeBudget = (e) => {
    var value = e.target.value + '';

    value = value.split('$')[1];

    this.setState({
      budget: e.target.value,
      budgetToSend: value,
      changedBudget: true,
    });
  };

  onChangeLinkValue = (e) => {
    this.setState({
      linkValue: e.target.value,
    });
  };

  handleChange = () => {
    this.setState({
      checked: !this.state.checked,
    });
  };

  render() {
    const {
      props: {
        showEditModal,
        media,
        feedReducer: { editModal },
      },
    } = this;

    return (
      <>
        {showEditModal === media.id && (
          <ReactModal
            isOpen={showEditModal === media.id}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={true}
            onRequestClose={() => this.closeModal()}
            style={{
              content: {
                height: 'auto',
                overflow: 'hidden',
                maxHeight: '50%',
                minHeight: '360px',
                width: '30%',
                margin: 'auto',
                background: '#fff',
                borderRadius: '10px',
                padding: '32px',
                overflow: 'visible',
              },
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                zIndex: '2004',
              },
            }}
          >
            {editModal.isLoading && (
              <LoadingWrapper>
                <LoadingOld isLoading={true} centerIcon />
              </LoadingWrapper>
            )}
            <Title>Editar</Title>
            {(media.status === 'active' || media.status === 'paused') && (
              <SwitchWrapper>
                {this.state.checked && <SwitchText>Pausar anúncio</SwitchText>}
                {!this.state.checked && <SwitchText>Ativar anúncio</SwitchText>}
                <Switch
                  checked={this.state.checked}
                  onChange={() => this.handleChange()}
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={13}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={16}
                  width={32}
                  disabled={media.status !== 'active' && media.status !== 'paused'}
                  className="react-switch"
                  id="material-switch"
                />
              </SwitchWrapper>
            )}

            <Subtitle>
              Quando você edita essas informações seu anúncio será enviado para revisão.
            </Subtitle>
            <Wrapper>
              <Period>
                <PeriodText>Período ESSE</PeriodText>
                <DatePicker
                  selected={this.state.startDate}
                  onChange={(date) => this.setStartDate(date)}
                  selectsStart
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  locale="pt-BR"
                  disabled={
                    media.status === 'paused' ||
                    media.status === 'active' ||
                    media.status === 'finished'
                  }
                />
                <div
                  style={{
                    marginRight: '6px',
                    marginLeft: '10px',
                    color: '#8BA4B1',
                    fontSize: '11px',
                  }}
                >
                  a
                </div>
                <DatePicker
                  selected={this.state.endDate}
                  onChange={(date) =>
                    this.setEndDate(date) || this.setState({ changedEndDate: true })
                  }
                  selectsEnd
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  locale="pt-BR"
                />
              </Period>
              <Budget>
                <PeriodText>{this.state.budgetType}</PeriodText>
                <div>
                  <CustomInput
                    prefix="R$"
                    thousandSeparator={'.'}
                    decimalSeparator={','}
                    placeholder={''}
                    value={this.state.budget}
                    onChangeEvent={this.changeBudget}
                    precision="0"
                  />
                </div>
              </Budget>
            </Wrapper>
            <LinkWrapper>
              <LinkLabel>Link de ação do anúncio</LinkLabel>
              <InputDefault
                type="text"
                id="link"
                name="link"
                onChange={this.onChangeLinkValue}
                value={this.state.linkValue}
              />
              <OptionalLabel>*opcional</OptionalLabel>
            </LinkWrapper>
            <FooterWrapper>
              <CancelButton onClick={this.closeModal}>Cancelar</CancelButton>
              <SaveApproveButton onClick={() => this.handleSubmit()}>Confirmar</SaveApproveButton>
            </FooterWrapper>
          </ReactModal>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    feedReducer: state.feedReducer,
    authenticationReducer: state.authenticationReducer,
  };
}

export default withRouter(connect(mapStateToProps)(EditModal));
